import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appBlurOnSearch]'
})
export class BlurOnSearchDirective {
  private static readonly BLUR_DELAY_MS = 100;
  private static readonly FOCUSABLE_TAGS = ['INPUT', 'TEXTAREA'];

  @HostListener('keydown.enter', ['$event'])
  onEnterKeyPress(event: KeyboardEvent): void {
    this.blurFocusedElement();
  }

  private blurFocusedElement(): void {
    // Use setTimeout to ensure blur happens after the search event is processed
    setTimeout(() => {
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement && this.isFocusableElement(activeElement)) {
        activeElement.blur();
      }
    }, BlurOnSearchDirective.BLUR_DELAY_MS);
  }

  private isFocusableElement(element: HTMLElement): boolean {
    return BlurOnSearchDirective.FOCUSABLE_TAGS.includes(element.tagName);
  }
}

